module.exports = __webpack_public_path__ + "static/img/gaojiao.027bc4d1.png";